import { z } from 'zod'
import { IncomeType } from '../../enums/income-type.enum'

export const updateCategorySchema = z.object({
  name: z.string().min(1, 'Name is required').max(100).optional(),
  description: z.string().max(500).optional(),
  color: z
    .string()
    .regex(/^#[0-9A-Fa-f]{6}$/, 'Color must be a valid hex color')
    .optional(),
  groupId: z.string().guid().nullable().optional(),
  incomeType: z.nativeEnum(IncomeType).optional(),
  isDefault: z.boolean().optional(),
})

export type UpdateCategoryDto = z.infer<typeof updateCategorySchema>
